import React from 'react'
import MessageUI from '../output/MessageUI'

const LabelAndValueUI = ({className, messageList, labelKey, label, align, children}) =>
  <div className={`w_lbl_val2 ${className ? className : ''}`}>
    <div className={`g_muted ${className ? '' : 'g_small'} ${align==='right'?'g_text_right':''}`}>
      {
        label && <span>{label}</span>
      }
      {
        labelKey &&
        <MessageUI messageList={messageList} messageKey={labelKey} />
      }
    </div>
    <div className={`${align==='right'?'g_text_right':''}`}>
      {children}
    </div>
  </div>

export default LabelAndValueUI
